import { Link } from "react-router-dom";

type Crumb = { name: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 font-label text-xs md:text-sm text-foreground-500">
        {items.map((item, idx) => (
          <li key={`${item.name}-${idx}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.name}</span>
            )}
            {idx < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}